<template>
  <b-card header="Billing" :header-bg-variant=bgVariant>
    <div v-if="!order.billingAddress">
      Loading...
    </div>
    <div v-else>
      <address-info :address="order.billingAddress" :is-shipping="false" />
    </div>
  </b-card>
</template>

<script>
import DataMerger from '../../utility/DataMerger.vue'
import orderMerger from '../../../services/orderMerge.js'
import AddressInfo from './AddressInfo.vue'

export default {
  data() {
    return {
    };
  },
  props: {
    order: { type: Object, required: true },
  },
  components: {
    DataMerger,
    AddressInfo,
  },
  computed: {
    bgVariant() {
      if (this.difference) {
        return 'danger'
      } else {
        return ''
      }
    },
    difference() {
      if (this.order.billingAddress) {
        return Object.keys(this.order.billingAddress).some((x) => {
          const dict = this.order.billingAddress[x]
          if (Object.keys(dict) < 2) return false

          return orderMerger.fieldDiffers(dict, true)
        });
      }
      return {}
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/sales-order/view-order-2/BillingAddress.vue